// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__24kiO","row":"Node_row__2Uppb","label":"Node_label__1r3ES","footer":"Node_footer__170oW"};